import React from 'react'
import { FileText, SquarePen } from 'lucide-react'
import { Link } from 'react-router-dom'
import { PHANTOM_PROJECT_PREFIX } from '../../../hooks/usePhantomProjectRedirect'

export interface ProjectHubActionLinksProps {
  projectId: string
  size?: 'sm' | 'md'
  className?: string
}

const SIZE_CLASS = {
  sm: 'h-7 w-7',
  md: 'h-8 w-8'
} as const

const ICON_SIZE = {
  sm: 13,
  md: 14
} as const

const baseLinkClass =
  'inline-flex items-center justify-center rounded-md flex-shrink-0 transition-colors ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-blueprint-blue/40 focus-visible:ring-offset-1'

export default function ProjectHubActionLinks({
  projectId,
  size = 'md',
  className = ''
}: ProjectHubActionLinksProps) {
  const dimension = SIZE_CLASS[size]
  const iconSize = ICON_SIZE[size]

  if (!projectId || projectId.startsWith(PHANTOM_PROJECT_PREFIX)) {
    return null
  }

  return (
    <div
      className={`flex items-center justify-end gap-1.5 ${className}`.trim()}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Link
        to={`/projects/${projectId}/edit`}
        onClick={(e) => e.stopPropagation()}
        title="Edit"
        aria-label="Edit"
        data-testid={`project-hub-edit-${projectId}`}
        className={`${baseLinkClass} ${dimension} border border-[#E2E5EA] bg-white text-blueprint-blue hover:bg-gray-50`}
      >
        <SquarePen size={iconSize} aria-hidden />
      </Link>
      <Link
        to={`/projects/${projectId}/mechanical-tests`}
        onClick={(e) => e.stopPropagation()}
        title="Reports"
        aria-label="Reports"
        data-testid={`project-hub-reports-${projectId}`}
        className={`${baseLinkClass} ${dimension} border border-transparent bg-hero-red text-white hover:bg-hero-red-60`}
      >
        <FileText size={iconSize} aria-hidden />
      </Link>
    </div>
  )
}
